export default "__VITE_ASSET__DYu6hQRU__"